export const PASSWORD_FLAG_KEYS = [
  'mustChangePassword',
  'must_change_password',
  'forcePasswordChange',
  'force_password_change',
  'requiresPasswordChange',
  'passwordChangeRequired',
];

export function resolveMustChangePasswordFlag(user: any): boolean {
  if (!user) {
    return false;
  }

  return PASSWORD_FLAG_KEYS.some((key) => {
    if (user[key] === undefined) {
      return false;
    }
    return Boolean(user[key]);
  });
}

export function normalizePasswordFlags<T extends Record<string, any>>(user: T | null): T | null {
  if (!user) {
    return user;
  }

  const normalized = { ...user } as T & { mustChangePassword?: boolean };
  normalized.mustChangePassword = resolveMustChangePasswordFlag(normalized);

  return normalized;
}

export function clearMustChangePasswordFlags<T extends Record<string, any>>(user: T | null): T | null {
  if (!user) {
    return user;
  }

  const updated = { ...user } as T & { mustChangePassword?: boolean };

  PASSWORD_FLAG_KEYS.forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(updated, key)) {
      (updated as any)[key] = false;
    }
  });

  updated.mustChangePassword = false;
  return updated;
}
